import type { NextPage } from "next"
import Head from "next/head"
import Link from "next/link"
import Script from "next/script"

import CourseCard from "../../components/courseCard"
import data from "../../components/data"

const CoursesIndex: NextPage = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Programavimo kursai",
    itemListElement: data.courses.map((course) => {
      return {
        "@type": "ListItem",
        position: course.position,
        url: `courses/${course.link}`,
      }
    }),
  }

  return (
    <div>
      <Head>
        <title>Pirmas kodas | Kursai</title>
        <meta
          name="description"
          // TODO autogenerate from course names
          content="Pirmas kodas siūlomi kursai: Python pradedantiesiems, Duomenų analizė su Python, Duomenų mokslas ir mašininis mokymasis su Python, Backend Web Dev su Python, Full stack Web Dev su Python ir Javascript (React, Tailwind) ir Web scraping su Python."
        />
      </Head>
      <Script
        id="schemaCourses"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      ></Script>
      <article className="prose max-w-none dark:prose-invert prose-h2:mt-0">
        <h1>Kursai</h1>
        {/* "grid grid-cols-1 md:grid-cols-2 gap-2 place-content-stretch"> */}
        <div className="grid grid-cols-1 gap-3">
          {data.courses.map((course) => (
            <CourseCard course={course} key={course.id} />
          ))}
        </div>
      </article>
    </div>
  )
}

export default CoursesIndex
